import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as Sentry from '@sentry/angular';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

import version from './version.json';

const isDeployedHost = window.location.host === environment.envBaseUrl;

const unsavedUserSetting = /\/user-setting\/[^/?]+/;

Sentry.init({
  dsn: 'https://4ed4f45b558b929100dd1e7c949c620b@o4507503317090304.ingest.us.sentry.io/4507627437817856',
  integrations: [
    // Registers and configures the Tracing integration,
    // which automatically instruments your application to monitor its
    // performance, including custom Angular routing instrumentation
    Sentry.browserTracingIntegration({}),
    // Registers the Replay integration,
    // which automatically captures Session Replays
    Sentry.replayIntegration(),

    Sentry.httpClientIntegration({
      failedRequestStatusCodes: [400, [402, 599]],
      failedRequestTargets: [/\/[a-z-]+-api\//],
    }),
  ],
  enabled: isDeployedHost,
  release: version.version,
  environment: window.location.hostname,
  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for tracing.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,

  // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
  tracePropagationTargets: ['localhost'],

  // Capture Replay for 10% of all sessions,
  // plus for 100% of sessions with an error
  replaysSessionSampleRate: 1.0,
  replaysOnErrorSampleRate: 1.0,

  ignoreSpans: [{ name: /\/assets\//, op: 'http.client' }],

  beforeSend(event) {
    const isUnsavedUserSetting =
      event.contexts?.['response']?.['status_code'] === 404 && unsavedUserSetting.test(event.request?.url ?? '');
    return isUnsavedUserSetting ? null : event;
  },
});

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch(err => console.error(err));
